import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from 'components/Box'
import Text from 'components/Text'

import { LeadChangedData, Notification } from 'types/global'

import { Highlight } from './styles'
import NotificationHeader from './NotificationHeader'
import NotificationFooter from './NotificationFooter'

type Props = Notification & {
  data: LeadChangedData
}

const LeadStatusUpdate: React.FC<Props> = ({ data: { leadName, newValue, oldValue }, ...props }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" paddingLeft="10px" width="100%" flexDirection="column">
      <NotificationHeader {...props} title="notification_lead_status_update_success" />
      <Box display="flex" paddingTop="4px">
        <Text lineHeight="22px">
          {t('Lead')}
          <Highlight>{leadName}</Highlight>
          {t('notification_lead_status_update_body', { newValue, oldValue })}
        </Text>
      </Box>
      <NotificationFooter {...props} />
    </Box>
  )
}

export default LeadStatusUpdate
